import { useEffect } from "react";
import Avatar from "@mui/material/Avatar";
import { getNameInitials } from "../constants/globalFunctions";
import { styled } from "@mui/material/styles";
import { useSelector, useDispatch } from "react-redux";
import { AvatarGroup } from "@mui/material";
import { fetchUserTagData } from "../../actions/setUserTagData";

const StyledAvatar = styled(Avatar)(({ size }) => ({
  "& img": {
    width: "100%",
    height: "100%",
    objectFit: "cover",
  },
  "&.MuiAvatar-root": {
    fontSize: size === "XXS" ? "0.5rem" : size === "XS" ? "0.5rem" : "1rem",
  },
}));

const getSizeClass = (size = "SM") => {
  switch (size) {
    case "XXS":
      return {
        width: "var(--size-20)",
        height: "var(--size-20)",
      };
    case "XS":
      return {
        width: "var(--size-24)",
        height: "var(--size-24)",
      };
    case "LSM":
      return {
        width: "var(--size-30)",
        height: "var(--size-30)",
      };
    case "SM":
      return {
        width: "var(--size-36)",
        height: "var(--size-36)",
      };
    case "LG":
      return {
        width: "var(--size-48)",
        height: "var(--size-48)",
      };
    case "LLG":
      return {
        width: "var(--size-75)",
        height: "var(--size-75)",
      };
    case "XL":
      return {
        width: "var(--size-100)",
        height: "var(--size-100)",
      };
    case "GR":
      return {
        width: "var(--size-40)",
        height: "var(--size-40)",
      };
    default:
      return {
        width: "var(--size-36)",
        height: "var(--size-36)",
      };
  }
};

function AvatarComponent({
  isCircle = false,
  isSquare = false,
  size = "SM",
  bgColor = "var(--system-colour-2)",
  style,
  id,
  fullName = "",
  maxAvatars,
  groupedAvatars,
  userIdsForGroup = [],
}) {
  const variant = isSquare ? "square" : isCircle ? "circular" : "circular";
  const dispatch = useDispatch();

  useEffect(() => {
    if (id) {
      dispatch(fetchUserTagData(id));
    }
  }, [id]);

  const { userTagData } = useSelector((state) => state);

  const avatarStyle = {
    backgroundColor: bgColor,
    ...getSizeClass(size),
    ...style,
    // border: "0",
  };

  if (maxAvatars) {
    return (
      <AvatarGroup
        variant="circular"
        max={maxAvatars}
        renderSurplus={(surplus) => {
          if (surplus >= 1000) {
            return <span>+{surplus.toString()[0]}k</span>;
          }
          return `+${surplus}`;
        }}
        slotProps={{
          additionalAvatar: {
            sx: {
              ...avatarStyle,
              fontSize: "0.75rem",
              border: "2px solid #fff",
            },
          },
        }}
      >
        {groupedAvatars}
      </AvatarGroup>
    );
  }

  return (
    <>
      {!userIdsForGroup.length && !maxAvatars && userTagData[id]?.data && userTagData[id]?.isLoaded && id ? (
        userTagData[id].data.profilePic ? (
          <StyledAvatar variant={variant} style={avatarStyle} size={size} src={userTagData[id].data.profilePic} />
        ) : (
          <StyledAvatar variant={variant} style={avatarStyle} size={size}>
            {getNameInitials({
              firstName: userTagData[id].data.firstName,
              lastName: userTagData[id].data.lastName,
            })}
          </StyledAvatar>
        )
      ) : (
        <StyledAvatar variant={variant} style={avatarStyle} size={size}>
          {getNameInitials({
            firstName: fullName.split(" ")[0] || "",
            lastName: fullName.split(" ")[1] || "",
          })}
        </StyledAvatar>
      )}
    </>
  );
}

export default AvatarComponent;
